import { render, staticRenderFns } from "./KkmSetOfdDataForm.vue?vue&type=template&id=4c2be604&"
import script from "./KkmSetOfdDataForm.vue?vue&type=script&lang=js&"
export * from "./KkmSetOfdDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports